import { cloneElement, useState, useTransition } from 'react';
import './CardProduct.scss';
import { Icon } from '../../icon/icon';
import ButtonTertiaryMedium from '../../common/ButtonTertiary/ButtonTertiaryMedium';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

const CardProductClick = ({
  md,
  title,
  description1,
  description2,
  onClick,
  onlyForAll = false,
}) => {
  // THÊM moduleType prop
  const [isLoading] = useState(false);
  const [isHover, setIsHover] = useState(false);

  const { t } = useTranslation();

  return (
    <div
      className={`card-product flex flex-col items-center w-[128px] rounded-[4px] bg-fills-white self-stretch hover:[&_.extend-action]:z-100 hover:[&_.extend-action]:opacity-1 [&_.extend-action]:opacity-0 [&_.extend-action]:-z-100 hover:[&_.card-image]:border-outline-brand-primary [&_.card-image]:border-transparent ${isLoading ? 'loading' : ''}`}
      onMouseOver={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      style={{
        opacity: isLoading ? 0.7 : 1,
        position: 'relative',
        cursor: 'pointer',
      }}
    >
      <div className="card-image transition-all ease-in-out duration-300 border-[2px] border-solid rounded-[4px] h-[157px] overflow-hidden">
        <img
          src={
            md?.icon ??
            'https://img.freepik.com/free-psd/3d-rendering-furniture-icon_23-2151445358.jpg'
          }
          alt=""
          className="object-cover h-full"
        />
        {/* <span
          className="w-16 h-16 flex absolute top-5 right-5"
          style={{ color: '#258FD2' }}
        >
          <Icon.ICInfoFill />
        </span> */}
      </div>

      <div className="flex p-8 flex-col items-center gap-4 self-stretch">
        {title && (
          <div className="flex items-start gap-6 self-stretch">
            <span className="text-body-medium-emphasized text-black-high line-clamp-1">
              {title}
            </span>
          </div>
        )}

        {description1 && (
          <div className="flex items-start gap-6 self-stretch">
            <p className="text-body-small text-black-medium line-clamp-2 w-full">
              {description1}
            </p>
          </div>
        )}
        {description2 && (
          <div className="flex items-start gap-6 self-stretch">
            <p className="text-supporting-xl text-black-medium line-clamp-2 w-full">
              {description2}
            </p>
          </div>
        )}
      </div>

      {/* Loading Indicator */}
      {isLoading && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'rgba(255,255,255,0.9)',
            padding: '5px 10px',
            borderRadius: '4px',
            color: '#007bff',
            fontSize: '12px',
            fontWeight: 'bold',
          }}
        >
          Loading...
        </div>
      )}

      <div
        className="extend-action gap-8 absolute left-0 right-0 items-center justify-center flex flex-col top-0 bottom-0 -z-10"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.16)' }}
      >
        {isHover ? (
          <Tooltip
            title={<span style={{ maxWidth: '200px' }}>{title}</span>}
            getPopupContainer={() => document.body}
            destroyOnHidden
            open
            placement="top"
          >
            <div
              className="flex gap-8 absolute left-0 right-0 items-center justify-center flex-col top-0 bottom-0"
              style={{ zIndex: -1 }}
            ></div>
          </Tooltip>
        ) : (
          <></>
        )}
        {onlyForAll === true ? null : (
          <ButtonTertiaryMedium
            posIcon={<Icon.ICCheck />}
            title={
              <span className="text-label-small">{t('Only this cabinet')}</span>
            }
            className={'rounded-[100px] bg-fills-white text-black/80'}
            onClick={e => {
              e.preventDefault();
              onClick?.(e, md);
            }}
          />
        )}

        <ButtonTertiaryMedium
          posIcon={<Icon.ICSelectAll />}
          title={<span className="text-label-small">{t('Apply to all')}</span>}
          className={'rounded-[100px] bg-fills-white text-black/80'}
          onClick={e => {
            e.preventDefault();
            onClick?.(e, md, true); // true để apply to all
          }}
        />
      </div>
    </div>
  );
};

export default CardProductClick;
